import { render, staticRenderFns } from "./CreateSlot.vue?vue&type=template&id=21e73168&scoped=true&"
import script from "./CreateSlot.vue?vue&type=script&lang=js&"
export * from "./CreateSlot.vue?vue&type=script&lang=js&"
import style0 from "./CreateSlot.vue?vue&type=style&index=0&id=21e73168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e73168",
  null
  
)

export default component.exports